class PolicyController {
  static controller ($scope) {
    'ngInject';
  };
}

export default PolicyController.controller;



// WEBPACK FOOTER //
// ./src/users/policy.controller.js